import { useLocalStorage } from 'react-use';
import { useStore } from 'effector-react';
import Button from '@components/Button';
import Checkbox from '@components/Checkbox';
import useToggle from '@hooks/useToggle';
import { IconLocked, IconUnlocked } from './icons';
import { $compareLocked, $compareLockedApi } from '../compareStores';

export function LockButton() {
  const locked = useStore($compareLocked);
  const [hideTip, setHideTip] = useLocalStorage('compare-lock-tip', false);
  const checked = useToggle(false);
  const tip = useToggle(!hideTip);
  return (
    <>
      <Button
        scheme={locked ? 'orange' : 'blue'}
        className="absolute right-10 top-10"
        onClick={() => {
          $compareLockedApi.set(!locked);
        }}
      >
        {locked ? <IconLocked active /> : <IconUnlocked active />}
        <span className="ml-5">{locked ? '解锁视角' : '锁定视角'}</span>
      </Button>
      {tip.isOn && (
        <div className="top absolute right-10 top-45 w-200 bg-black-black/50 p-10">
          <div className="leading-[24px]">
            将“原始场景”和“对比场景”画面中的同一特征参考点调整至中心红点位置。然后，锁定视角，即可实现场景对齐。
          </div>
          <div className="mt-10 flex items-center">
            <Checkbox
              checked={checked.isOn}
              label="不再提示"
              onToggle={checked.set}
            />
            <Button
              size="sm"
              className="ml-auto"
              onClick={() => {
                tip.off();
                if (checked.isOn) {
                  setHideTip(true);
                }
              }}
            >
              我知道了
            </Button>
          </div>
        </div>
      )}
    </>
  );
}
